import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserClientMemberImplEncoder } from "../../encoder/UserClientMemberImplEncoder";

import * as CubiqTS from "../../index";
import { UserClientMember } from "../UserClientMember";

export class UserClientMemberImpl extends ConcreteEncodable implements UserClientMember {
  public static enType: string = "com.bcdfx.model.UserClientMemberImpl";

  /*FID=1*/
  public clientCd: string;
  /*FID=2*/
  public clientTraderId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserClientMemberImplEncoder.Instance;
    this.setEncodableType(UserClientMemberImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UserClientMemberImpl[" +
      "clientCd=" +
      this.clientCd +
      "clientTraderId=" +
      this.clientTraderId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
